import { useLocation } from 'react-router-dom';
import React from 'react';
import DashboardHelp, {
  ActivityHelp,
  ChatHelp,
  EditProfileHelp,
  JobMatchesHelp,
  JobsHelp,
  MyProfileHelp,
} from '../SharedComponents/HelpButtonComponents/HelpContent/HelpTemplates';

const LoadHelpContent = () => {
  const location = useLocation();

  if (location.pathname === '/dashboard') {
    return <DashboardHelp />;
  } else if (location.pathname === '/profile' || location.pathname === '/Profile') {
    return <MyProfileHelp />;
  } else if (
    location.pathname.startsWith('/profile/edit') ||
    location.pathname.startsWith('/Profile/edit')
  ) {
    return <EditProfileHelp />;
  } else if (location.pathname.startsWith('/jobs') || location.pathname.startsWith('/Jobs')) {
    return <JobsHelp />;
  } else if (
    location.pathname.startsWith('/myjobmatches') ||
    location.pathname.startsWith('/Myjobmatches')
  ) {
    return <JobMatchesHelp />;
  } else if (
    location.pathname.startsWith('/activity') ||
    location.pathname.startsWith('/Activity')
  ) {
    return <ActivityHelp />;
  } else if (location.pathname.startsWith('/chat') || location.pathname.startsWith('/Chat')) {
    return <ChatHelp />;
  } else return null;
};

export default LoadHelpContent;
